import React from 'react';

import { Position, PositionModal } from '../../../shared/modal/PositionModal';
import styles from './DatasetComponents.module.scss';
import { InformationTooltip } from '../../../shared/tooltip';

interface FieldConfigModalProps {
    isOpen: boolean;
    closeModal: () => void;
    position: Position | null;
    value: string;
    updateValue: (val: string) => void;
    disabled: boolean;
    headerLabel: string;
    description: string;
    placeholder: string;
    testId: string;
    maxLength?: number;
}

export const FieldConfigModal: React.FC<FieldConfigModalProps> = ({ closeModal, isOpen, position, updateValue, value, disabled, headerLabel, description, placeholder, testId, maxLength = 500 }) => (
    <PositionModal
        isOpen={isOpen}
        position={position}
        closeModal={closeModal}
        testId={testId}
        height='120px'
        width='400px'
        maxWidth='400px'
    >
        <div className={styles.fieldConfigModalWrapper}>
            <div className={styles.fieldConfigModalHeaderWrapper} data-testid={`${testId}-header-wrapper`}>
                <div className={styles.fieldConfigHeader} data-testid={`${testId}-header`}>{headerLabel}</div>
                <div className={styles.fieldConfigInfo}><InformationTooltip content={description} /></div>
            </div>
            <div className={styles.fieldConfigInputWrapper}>
                <textarea
                    style={{ resize: 'none' }}
                    maxLength={maxLength}
                    className={styles.fieldConfigInput}
                    placeholder={placeholder}
                    value={value}
                    onChange={e => updateValue(e.target.value)}
                    data-testid={`${testId}-input`}
                    disabled={disabled}
                />
            </div>
        </div>
    </PositionModal>
);
